function place(item, direction) {
  return [item[`${direction}_area`], item[`${direction}_location`], item[`${direction}_location_detail`], direction === 'dropoff' ? item.destination : ''].filter(Boolean).join(' ');
}

function airport(value) {
  if (/haneda[_\s-]*(?:international[_\s-]*)?airport|羽田|\bhnd\b/i.test(value)) return 'haneda';
  if (/narita[_\s-]*(?:international[_\s-]*)?airport|成田(?:国际|国際)?(?:机场|空港)|\bnrt\b/i.test(value)) return 'narita';
  return null;
}

function region(value) {
  if (/hakone|箱根|(?:^|[\s_-])fuji(?:$|[\s_-])|(?:mt\.?|mount)[\s_-]*fuji\b|fujikawaguchiko|fujiyoshida|fujisan|富士山|富士吉田|河口湖|山中湖|御殿場|御殿场/i.test(value)) return 'hakone_fuji';
  if (/tokyo|東京|东京|(?:千代田|中央|港|新宿|文京|台東|台东|墨田|江東|江东|品川|目黒|目黑|大田|世田谷|渋谷|涩谷|中野|杉並|杉并|豊島|丰岛|北|荒川|板橋|板桥|練馬|练马|足立|葛飾|葛饰|江戸川|江户川)区/i.test(value)) return 'tokyo';
  return null;
}

export function getScheduleRouteLabel(item) {
  const label = (direction) => {
    const value = place(item, direction);
    const airportName = airport(value);
    if (airportName) return airportName === 'haneda' ? '羽田' : '成田';
    if (/hakone|箱根/i.test(value)) return '箱根';
    if (region(value) === 'hakone_fuji') return '富士山';
    if (region(value) === 'tokyo') return '东京';
    return item[`${direction}_area`] || item[`${direction}_location`] || item[`${direction}_location_detail`] || (direction === 'dropoff' ? item.destination : '') || '未设置';
  };
  return `${label('pickup')} → ${label('dropoff')}`;
}

export function getScheduleDurationHours(item) {
  if (item?.service_type === 'charter') {
    const hours = Number(item.selected_hours || item.charter_hours || item.duration_hours);
    return Number.isFinite(hours) && hours > 0 ? hours : 8;
  }
  const pickup = place(item || {}, 'pickup');
  const dropoff = place(item || {}, 'dropoff');
  const pickupAirport = airport(pickup);
  const dropoffAirport = airport(dropoff);
  // Airport-to-airport transfers are not covered by the city/airport duration table.
  if (Boolean(pickupAirport) !== Boolean(dropoffAirport)) {
    const arrival = Boolean(pickupAirport);
    const destinationRegion = region(arrival ? dropoff : pickup);
    const airportName = pickupAirport || dropoffAirport;
    const table = { tokyo: { haneda: 1, narita: 1.5 }, hakone_fuji: { haneda: 2.5, narita: 3.5 } };
    if (destinationRegion) return table[destinationRegion][airportName] + (arrival ? 1 : 0);
  }
  const hours = Number(item?.duration_hours);
  return Number.isFinite(hours) && hours > 0 ? hours : 2;
}
